import * as React from 'react';
import { useSelector } from 'react-redux';
import { ModalWindow } from '@cian/ui-kit';

import { selectIsOnboardingModalOpen } from '../../selectors/selectIsOnboardingModalOpen';

import { OnboardingContainer } from './parts';
import { openOnboardingModal } from '../../slices';
import { useAppDispatch } from '../../hooks';
import { trackCloseOnboardingModal, getOnboardingCloseFromCookie, setOnboardingCloseCookies } from './utils';

export const OnboardingModalContainer: React.FC = () => {
  const dispatch = useAppDispatch();

  const isOnboardingModalOpen = useSelector(selectIsOnboardingModalOpen);

  const handleCloseModal = React.useCallback(() => {
    dispatch(openOnboardingModal(false));
    trackCloseOnboardingModal();

    setOnboardingCloseCookies();
  }, [dispatch]);

  React.useEffect(() => {
    const onboardingCloseFromCookie = getOnboardingCloseFromCookie();

    dispatch(openOnboardingModal(!onboardingCloseFromCookie));
  }, []);

  return (
    <ModalWindow open={isOnboardingModalOpen} onClose={handleCloseModal}>
      <OnboardingContainer />
    </ModalWindow>
  );
};
